var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-action"},[_c('a',{staticClass:"header-action__link",class:{
            'header-action__link--active': _vm.active
        },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }